
import styles from './Title.module.scss';
import cn from 'classnames';
export const Title = ({tag: Tag = 'h1', children, className, ...props }) => {
  return (
    <Tag className={cn(styles.title, className)} {...props}>{children}</Tag>
  )
}